'use client'

import type { MenuItem, MenuSeparator } from '@graftcode/design-system'
import { Icon } from '@graftcode/design-system'

import { MenuActionId } from './enums'

export const BASE_PROJECT_ITEMS: (MenuItem | MenuSeparator)[] = [
  {
    type: 'item',
    icon: Icon.SettingsRegular,
    active: true,
    groups: [],
    label: 'Settings',
    id: MenuActionId.PROJECT_SETTINGS,
    size: 'xs',
  },
  {
    type: 'item',
    icon: Icon.PeopleRegular,
    active: true,
    groups: [],
    label: 'Project members',
    id: MenuActionId.PROJECT_MEMBERS,
    size: 'xs',
  },
  {
    type: 'item',
    icon: Icon.PeopleAddRegular,
    active: true,
    groups: [],
    label: 'Invite people',
    id: MenuActionId.INVITE_PEOPLE,
    size: 'xs',
  },
  {
    id: 'sep-1',
    type: 'separator',
  },
]

export const BASE_WORKSPACE_ITEMS: (MenuItem | MenuSeparator)[] = [
  {
    type: 'item',
    active: true,
    groups: [],
    label: 'Settings',
    icon: Icon.SettingsRegular,
    id: MenuActionId.WORKSPACE_SETTINGS,
    size: 'xs',
  },
  {
    type: 'item',
    active: true,
    groups: [],
    label: 'Invite people',
    icon: Icon.PeopleAddRegular,
    id: MenuActionId.INVITE_PEOPLE,
    size: 'xs',
  },
  {
    id: 'sep-1',
    type: 'separator',
  },
]

export const DEFAULT_PROFILE_ITEMS: (MenuItem | MenuSeparator)[] = [
  {
    type: 'item',
    active: true,
    groups: [],
    label: '',
    subLabel: '',
    id: 'profile-info',
  },
  {
    type: 'item',
    active: true,
    groups: [],
    icon: Icon.SettingsRegular,
    label: 'Settings',
    id: 'settings',
    size: 'xs',
  },
  {
    type: 'item',
    active: false,
    icon: Icon.EarthRegular,
    label: 'Region',
    id: 'region',
    size: 'xs',
    groups: [
      {
        id: 'group-1',
        items: [
          {
            type: 'item',
            active: true,
            groups: [],
            label: 'Europe',
            id: 'region-europe',
            iconSize: 20,
          },
          {
            type: 'item',
            active: true,
            groups: [],
            label: 'North america',
            id: 'region-na',
            selected: true,
            iconSize: 20,
          },
        ],
      },
    ],
  },
  {
    id: 'sep-1',
    type: 'separator',
  },
  {
    type: 'item',
    icon: Icon.ArrowExitRegular,
    iconSize: 20,
    active: true,
    groups: [],
    label: 'Logout',
    id: 'logout',
  },
]

export function createSwitchProjectItem(projectGroupItems: MenuItem[]): MenuItem {
  const groups: MenuItem['groups'] = []

  if (projectGroupItems.length > 0) {
    groups.push({
      id: 'group-1',
      searchable: true,
      label: 'Projects',
      separatorAfter: true,
      items: projectGroupItems,
    })
  }

  groups.push({
    id: 'group-2',
    items: [
      {
        type: 'item',
        icon: Icon.AddRegular,
        active: true,
        groups: [],
        label: 'Create project',
        id: MenuActionId.CREATE_PROJECT_DIALOG,
        size: 'xs',
      },
    ],
  })

  return {
    type: 'item',
    icon: Icon.FolderRegular,
    active: true,
    label: 'Switch project',
    id: 'item-5',
    size: 'xs',
    groups,
  }
}
